module.exports = __webpack_public_path__ + "static/media/S2N12-3.3be27238.svg";